export enum ShotOnTargetAttribute {
  BicycleKick = 846,
  BigChanceMissed = 888,
  BottomLeft = 434,
  BottomMiddle = 433,
  BottomRight = 435,
  Chip = 847,
  ClearPosition = 914,
  DirectFreeKick = 406,
  EasySave = 891,
  EmptyNet = 918,
  FirstTouch = 910,
  GoallineClearance = 731,
  Head = 429,
  HighPressure = 913,
  ImportantSave = 894,
  InsidePenaltyArea = 427,
  LeftFoot = 404,
  LightPressure = 912,
  NoPressure = 911,
  Normal = 909,
  OneDefender = 915,
  OneOnOne = 848,
  OtherBodyPart = 919,
  OutsidePenaltyArea = 428,
  PowerShot = 844,
  RightFoot = 405,
  SpectacularSave = 897,
  TwoOrMoreDefenders = 916,
  UncomfortablePosition = 917,
  UpperLeft = 430,
  UpperMiddle = 432,
  UpperRight = 431,
  Volley = 845,
}
